type AppEnv = "local" | "dev" | "prod" | "demo";

export const currentEnv: AppEnv = "prod";

export const Env: AppEnv = currentEnv;

const API_LOCAL_URL = "http://localhost:8000";
const API_DEV_URL = "https://api.dev.easymarket.sn";
const API_DEMO_URL = "https://api.easymarket.sn";
const API_PROD_URL = "https://api.easymarket.sn";

// prod API Key = "659f9d4a2f974dee45379d99dffdd91195a2cd81aa6a21e19c4081a714a6242d";
// // local API Key = "5ce65db6ff7ae13c0f517432a3b186f25217a69c2e429561f0e416d5f6e0b8b6";

const VENDEUR_APIKEY_LOCAL =
  "5ce65db6ff7ae13c0f517432a3b186f25217a69c2e429561f0e416d5f6e0b8b6";
const VENDEUR_APIKEY_DEMO =
  "659f9d4a2f974dee45379d99dffdd91195a2cd81aa6a21e19c4081a714a6242d";
const VENDEUR_APIKEY_PROD =
  "659f9d4a2f974dee45379d99dffdd91195a2cd81aa6a21e19c4081a714a6242d";

export const APP_URL_LOCAL = "http://localhost:3000/";
export const APP_URL_DEV = "https://recette.dev.easymarket.sn/";
export const APP_URL_DEMO = "https://pureessencesenegal.com/";
export const APP_URL_PROD = "https://pureessencesenegal.com/";

function processApiUrl() {
  if (Env === "local") return API_LOCAL_URL;
  if (Env === "prod") return API_PROD_URL;
  if (Env === "demo") return API_DEMO_URL;
  return API_DEV_URL;
}

function processAppUrl() {
  if (Env === "local") return APP_URL_LOCAL;
  if (Env === "prod") return APP_URL_PROD;
  if (Env === "demo") return APP_URL_DEMO;
  return APP_URL_DEV;
}

function processApikey() {
  if (Env === "local") return VENDEUR_APIKEY_LOCAL;
  if (Env === "prod") return VENDEUR_APIKEY_PROD;
  if (Env === "demo") return VENDEUR_APIKEY_DEMO;
  return VENDEUR_APIKEY_DEMO;
}

export const ApiBaseUrl = processApiUrl();
export const AppBaseUrl = processAppUrl();

export const VendeurApikey = processApikey();

export const GoogleApikey = "AIzaSyChXWZKmUgaWFvIV2WnTVoR2lY3-uhReBg";

export const IntechApikey = "";

export const GoogleClientId =
  "701177325323-33rje48k1alj39qmb9vspat9urmmrojn.apps.googleusercontent.com";
